module.exports = {
    JOB_COMPLETED: 'sse.job.completed',
    SSE_CITY_REFRESH: 'sse.city.refresh',
    SSE_PARAMETER_REFRESH: 'sse.parameter.refresh',
    SSE_UNIT_REFRESH: 'sse.unit.refresh',
    SSE_TAXON_REFRESH: 'sse.taxon.refresh',
    SSE_CONTRIBUTOR_REFRESH: 'sse.contributor.refresh',
    SSE_CONTACT_REFRESH: 'sse.contact.refresh',
    SSE_QUALITO_REFRESH: 'sse.qualito.refresh',
    SSE_PIEZO_REFRESH: 'sse.piezo.refresh',
    SSE_HYDRO_REFRESH: 'sse.hydro.refresh',
    SSE_PLUVIO_REFRESH: 'sse.pluvio.refresh',
    REFERENCIAL_PARAMETER_PURGE_LOADING: 'referencial.paremeter.purge.loading',
    REFERENCIAL_PARAMETER_PURGED: 'referencial.parameter.purged',
}
